import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a357ae5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-lg-500px bg-secondary rounded shadow-sm p-10 p-lg-15 mx-auto",
  style: {"--bs-bg-opacity":"0.2"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-left mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold text-dark mb-3 text-center title fw-light" }, " Nueva Contraseña ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-gray-900 fs-base" }, "Contraseña provisional", -1))
const _hoisted_4 = { class: "position-relative" }
const _hoisted_5 = { class: "position-absolute translate-middle-y top-50 end-0 me-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 start-0 ms-4" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "button",
    class: "svg-icon svg-icon-1hx pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key text-white fs-4" })
  ])
], -1))
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-gray-900 fs-base" }, "Establece una nueva contraseña", -1))
const _hoisted_11 = { class: "position-relative" }
const _hoisted_12 = { class: "position-absolute translate-middle-y top-50 end-0 me-5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 start-0 ms-4" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "button",
    class: "svg-icon svg-icon-1hx pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key text-white fs-base" })
  ])
], -1))
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "messages" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-auto col-6 text-center" }
const _hoisted_19 = { class: "mb-0 mt-1 fs-sm" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-1 fs-sm" }, "Caracteres", -1))
const _hoisted_21 = { class: "col-md-auto col-6 text-center fs-sm" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-1 fs-sm" }, "1", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-1 fs-sm" }, "Mayúscula", -1))
const _hoisted_24 = { class: "col-md-auto col-6 text-center fs-sm" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-1 fs-sm" }, "1", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-1 fs-sm" }, "Minúscula", -1))
const _hoisted_27 = { class: "col-md-auto col-6 text-center fs-sm" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-1 fs-sm" }, "1", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-1 fs-sm" }, "Número", -1))
const _hoisted_30 = { class: "col-md-auto col-6 text-center fs-sm" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-1 fs-sm" }, "1", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-1 fs-sm" }, "Símbolo", -1))
const _hoisted_33 = { class: "fv-row mb-10" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold text-gray-900 fs-base" }, "Repite la contraseña", -1))
const _hoisted_35 = { class: "position-relative" }
const _hoisted_36 = { class: "position-absolute translate-middle-y top-50 end-0 me-5" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle-y top-50 start-0 ms-4" }, [
  /*#__PURE__*/_createElementVNode("span", {
    role: "button",
    class: "svg-icon svg-icon-1hx pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key text-white fs-4" })
  ])
], -1))
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_41 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_password_reset_submit",
  class: "btn btn-lg btn-primary fw-bolder me-4"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label fs-base fw-bold" }, " Establecer contraseña ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress fs-base fw-bold" }, [
  /*#__PURE__*/_createTextVNode(" Espera por favor... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
      onSubmit: _ctx.onSubmitForgotPassword,
      id: "kt_login_password_reset_form",
      "validation-schema": _ctx.forgotPassword
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", {
          class: _normalizeClass(["fv-row mb-10", _ctx.$route.params.pwd ? 'd-none' : ''])
        }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Field, {
              class: "form-control form-control-solid fs-base ps-12 pe-20 mb-1",
              type: _ctx.$route.params.pwd ? 'hidden' : _ctx.type1,
              name: "provisional",
              modelValue: _ctx.provisional,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.provisional) = $event)),
              autocomplete: "off",
              style: {"background":"none","border":"1px solid gray"}
            }, null, 8, ["type", "modelValue"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleType(1))),
                role: "button",
                class: "svg-icon svg-icon-1hx pointer text-white"
              }, _toDisplayString(_ctx.type1 == "password" ? "Mostrar" : "Ocultar"), 1)
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ErrorMessage, { name: "provisional" })
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Field, {
              class: "form-control form-control-solid ps-12 pe-20",
              type: _ctx.type2,
              onInput: _ctx.checkTerms,
              name: "password",
              style: {"background":"none","border":"1px solid gray"}
            }, null, 8, ["type", "onInput"]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleType(2))),
                role: "button",
                class: "svg-icon svg-icon-1hx pointer text-white"
              }, _toDisplayString(_ctx.type2 == "password" ? "Mostrar" : "Ocultar"), 1)
            ]),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: _normalizeClass(
                  _ctx.checks.min
                    ? 'bg-success flex-grow-1 rounded h-5px mt-1'
                    : 'bg-secondary flex-grow-1 rounded h-5px mt-1'
                )
                }, null, 2),
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.characters), 1),
                _hoisted_20
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", {
                  class: _normalizeClass(
                  _ctx.checks.mayus
                    ? 'bg-success flex-grow-1 rounded h-5px mt-1'
                    : 'bg-secondary flex-grow-1 rounded h-5px mt-1'
                )
                }, null, 2),
                _hoisted_22,
                _hoisted_23
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", {
                  class: _normalizeClass(
                  _ctx.checks.minus
                    ? 'bg-success flex-grow-1 rounded h-5px mt-1'
                    : 'bg-secondary flex-grow-1 rounded h-5px mt-1'
                )
                }, null, 2),
                _hoisted_25,
                _hoisted_26
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  class: _normalizeClass(
                  _ctx.checks.number
                    ? 'bg-success flex-grow-1 rounded h-5px mt-1'
                    : 'bg-secondary flex-grow-1 rounded h-5px mt-1'
                )
                }, null, 2),
                _hoisted_28,
                _hoisted_29
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", {
                  class: _normalizeClass(
                  _ctx.checks.special
                    ? 'bg-success flex-grow-1 rounded h-5px mt-1'
                    : 'bg-secondary flex-grow-1 rounded h-5px mt-1'
                )
                }, null, 2),
                _hoisted_31,
                _hoisted_32
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_Field, {
              class: "form-control form-control-solid ps-12 pe-20",
              type: _ctx.type3,
              name: "password_confirm",
              style: {"background":"none","border":"1px solid gray"}
            }, null, 8, ["type"]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("span", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleType(3))),
                role: "button",
                class: "svg-icon svg-icon-1hx pointer text-white"
              }, _toDisplayString(_ctx.type3 == "password" ? "Mostrar" : "Ocultar"), 1)
            ]),
            _hoisted_37
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_ErrorMessage, { name: "password_confirm" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("button", _hoisted_41, _hoisted_44, 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}